module.exports = __webpack_public_path__ + "static/media/normon@3x.6bc12759.jpg";